import produce from "immer";
import { OnlineDsaLimitActions } from ".";
import { LoadState } from "../../constants/enums";
import { IStoreState } from "../initialStoreState";
import { CLEAR_ONLINE_DSA_LIMIT_STATE, clearOnlineDsaLimitState, FETCH_ONLINE_DSA_LIMIT_FAILURE, FETCH_ONLINE_DSA_LIMIT_PROGRESS, FETCH_ONLINE_DSA_LIMIT_SUCCESS, FETCH_SINGLE_ONLINE_DSA_LIMIT_FAILURE, FETCH_SINGLE_ONLINE_DSA_LIMIT_PROGRESS, FETCH_SINGLE_ONLINE_DSA_LIMIT_SUCCESS } from "./OnlineDsaLimit.action";
import { OnlineDsaLimitInitialState } from "./OnlineDsaLimit.state";


export const onlineDsaLimitReducer = (
    state: IStoreState["onlineDsaLimit"] = OnlineDsaLimitInitialState,
    action: OnlineDsaLimitActions
) => {
    switch (action.type) {
        case FETCH_ONLINE_DSA_LIMIT_PROGRESS: {
            const newState = produce(state, (draftState) => {
                draftState.list.loading = LoadState.InProgress;
                // draftState.list.data = [];
                draftState.list.totalRecords = 0;
            });
            return newState;
        }
        case FETCH_ONLINE_DSA_LIMIT_SUCCESS: {
            const { data, totalRecords } = action.payload;
            const newState = produce(state, (draftState) => {
                draftState.list.loading = LoadState.Loaded;
                // draftState.list.data = data;
                draftState.list.totalRecords = totalRecords;
            });
            return newState;
        }
        case FETCH_ONLINE_DSA_LIMIT_FAILURE: {
            const newState = produce(state, (draftState) => {
                draftState.list.loading = LoadState.InProgress;
                // draftState.list.data = [];
                draftState.list.totalRecords = 0;
            });
            return newState;
        }
        case FETCH_SINGLE_ONLINE_DSA_LIMIT_PROGRESS: {
            const newState = produce(state, (draftState) => {
                // draftState.onlineDsaLimit.loading = LoadState.InProgress;
            });
            return newState;
        }
        
        case FETCH_SINGLE_ONLINE_DSA_LIMIT_FAILURE: {
            const newState = produce(state, (draftState) => {
                // draftState.OnlineDsaLimit.loading = LoadState.InProgress;
            });
            return newState;
        }
        case CLEAR_ONLINE_DSA_LIMIT_STATE: {
            return OnlineDsaLimitInitialState;
        }
        default: {
            return state;
        }
    }
}
